<kendo-formfield class="kendo-formfield left-search-icon multi">
  <div *ngIf="isAdmin" class="investigator-header">
    <kendo-label text="Investigators" [for]="multiSelect"></kendo-label>
    <label class="show-all-users-label">
      <input type="checkbox" class="k-checkbox k-checkbox-md" [checked]="showAllUsers"
        (change)="onShowAllUsersChange($any($event.target).checked)" />
      Show All Users
    </label>
  </div>
  <div style="position: relative;">
    <i class="fa fa-search" aria-hidden="true"></i>
    <kendo-multiselect #multiSelect [checkboxes]="true" [autoClose]="false" [loading]="loading" [valuePrimitive]="true"
      [data]="groupedUsers" [(ngModel)]="selectedId" [ngModelOptions]="{ standalone: true }" [rounded]="'full'"
      (valueChange)="selectUser($event)" valueField="id" textField="itemFullName" [placeholder]="'Search Investigator'"
      [popupSettings]="{ popupClass: 'investigator-filter-popup' }" [fillMode]="'outline'" [filterable]="true"
      (filterChange)="onSearchChange($event)" (keydown.enter)="onEnterPress()">
      <ng-template kendoMultiSelectGroupTemplate let-groupName>
        <div class="group-header-content" (click)="$event.stopPropagation()">
          <input type="checkbox" #groupHeaderCheckbox class="k-checkbox k-checkbox-md"
            [checked]="isGroupSelected(groupName)" [indeterminate]="isGroupIndeterminate(groupName)"
            (change)="toggleGroup(groupName, $event)" />
          <strong style="margin-left: 8px;" (click)="groupHeaderCheckbox.click()">{{ groupName }}</strong>
        </div>
      </ng-template>
      <ng-template kendoMultiSelectFixedGroupTemplate let-groupName>
        <div class="group-header-content" (click)="$event.stopPropagation()">
          <input type="checkbox" #groupHeaderFixedCheckbox class="k-checkbox k-checkbox-md"
            [checked]="isGroupSelected(groupName)" [indeterminate]="isGroupIndeterminate(groupName)"
            (change)="toggleGroup(groupName, $event)" />
          <strong style="margin-left: 8px;" (click)="groupHeaderFixedCheckbox.click()">{{ groupName }}</strong>
        </div>
      </ng-template>
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <input type="checkbox" class="k-checkbox k-checkbox-md" [checked]="isSelected(dataItem)"
          style="margin-right: 8px; pointer-events: none;" />
        <div style="padding-left: 5px;" class="dropdown-option">
          <span>{{ dataItem.itemFullName }} </span>
          <span class="state-suffix">{{dataItem?.HomeAddress.city + ', ' +
            dataItem?.HomeAddress?.state}}</span>
        </div>
      </ng-template>
      <ng-template kendoMultiSelectNoDataTemplate *ngIf="!searchString?.trim()?.length && !loading">
        No staff members found.
      </ng-template>
      <ng-template kendoMultiSelectNoDataTemplate *ngIf="searchString?.trim()?.length && !loading">
        No matches for "{{ searchString }}"
      </ng-template>
    </kendo-multiselect>
  </div>
</kendo-formfield>
